const manutencao_das_vagas_item = {
  path: "/manutencao-das-vagas",
  redirect: "/manutencao-das-vagas",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Vagas",
  },
  children: [
    {
      path: "/manutencao-das-vagas",
      name: "manutencao_das_vagas",
      meta: {
        allowedPermissions: ["estrutura_turma_atualiza_vaga"],
      },
      component: () =>
        import("@/views/ManutencaoDasVagas/ManutencaoDasVagas.vue"),
    },
  ],
};

export { manutencao_das_vagas_item };
